export default {
  admin: {
    invoice: {
      title: "Facturación — Codificación contable",
      tab: {
        payers: "Terceros pagadores",
        chrono: "Numeración de documentos contables",
        article_codes: "Códigos de artículos",
        terms_of_payment: "Condiciones de pago",
        bank_details: "Datos bancarios",
      },
      alert: {
        locked: "Configuración bloqueada por el administrador de la plataforma",
        payer:
          "Estos valores se heredan por cada empresa en el momento de su creación. Siguen siendo modificables individualmente en la ficha de la empresa.",
        article_code:
          "El código está bloqueado y no se puede modificar. Todos los demás campos son personalizables: haga clic en el lápiz para editar una fila.",
        payment_code:
          "Estos referenciales alimentan los asientos contables transmitidos a Sage. Códigos definidos por el equipo STUDEA — no modificables.",
        bank_details:
          "Información confidencial — transmitida a la API Convergence y mostrada en los documentos contables.",
      },
      payers: {
        actions: {
          apply_collective_account: {
            title: "Aplicar la cuenta colectiva",
            subtitle: "A las empresas privadas sin cuenta definida",
            subtitle_public: "A las empresas públicas sin cuenta definida",
          },
          payment_terms: {
            title: "Aplicar las condiciones de pago",
            subtitle: "A las empresas privadas sin condiciones definidas",
            subtitle_public: "A las empresas públicas sin condiciones definidas",
          },
          missing_subsidiary_ledgers: {
            title: "Generar las cuentas auxiliares faltantes",
            subtitle: "Los números existentes no se sobrescribirán",
          },
        },
        update: {
          success: "¡Datos actualizados correctamente!",
        },
        apply: {
          success: "{count} empresa(s) actualizada(s)",
          opco: {
            success: "{count} OPCO(s) actualizado(s)",
          },
        },
      },
      article_code: {
        edit: {
          success: "¡Código de artículo modificado correctamente!",
        },
      },
      action: {
        deactivate: "Desactivar",
        activate: "Activar",
      },
      payment_code: {
        activated: {
          success: ({ plural }) => plural(["¡Código desactivado correctamente!", "¡Código activado correctamente!"]),
        },
        toggle_error: "Error al actualizar los datos mostrados, por favor actualice la página",
      },
      bank_details: {
        success: "¡Datos bancarios modificados correctamente!",
      },
    },
    help_settings: "Parámetros de la ayuda",
    help_settings_success: "Parámetros de la ayuda modificados correctamente",
    lastEmail: "Enlace del último correo enviado",
    generatePassword: "Volver a generar y enviar la contraseña",
    switchUser: "Representar a {name}",
    switchAdmin: "Está representando a",
    switchAdminLabel: "Administrador",
    switchPilot: "Responsable del cuaderno",
    show: "Ver {title}",
    modify: "Modificar {title}",
    delete: "Eliminar {title}",
    add: "Añadir",
    name: "Nombre",
    title: "Título",
    year: "Año",
    trainingOpeningStart: "Inicio de la inscripción en la formación",
    trainingOpeningEnd: "Fin de la inscripción en la formación",
    level: "Nivel",
    registrationDate: "Fecha de registro",
    active: "Activo",
    management_of: "Gestión de",
    contents: "contenidos",
    users: "Usuarios",
    trainings: "Formaciones",
    archiving: {
      title: "Archivado",
      action: "Archivar",
      archive_confirmation: "¿Está seguro de que desea archivar estas promociones?",
      unarchive_confirmation: "¿Está seguro de que desea desarchivar estas promociones?",
      archive_success: "¡Promociones archivadas con éxito!",
      active_confirmation: "¿Está seguro de que desea desarchivar estas promociones?",
      active_success: "¡Promociones desarchivadas con éxito!",
      unarchive_success: "¡Promociones desarchivadas con éxito !",
    },
    current_training_course_year: {
      title: "Modificar el año en curso",
      error: "El año de referencia debe ser diferente del nuevo año en curso.",
      confirmation: {
        title: "¿Está seguro de que desea cambiar el año en curso?",
        subtitle: "Se modificará en todas las promociones cuyo año de inicio coincida con el año de referencia.",
      },
      success: ({ named }) => `Año en curso cambiado en ${named("count")} promociones`,
    },
    livretConfig: {
      title: "Activación del cuaderno",
      confirmation: "¿Confirmar la modificación de estos datos?",
      success: "¡Configuración del cuaderno guardada con éxito!",
    },
    modules: "Módulos",
    module: "Módulo",
    code: "Código",
    error: "Se ha producido un error. Vuelva a intentarlo más tarde",
    lastName: "Apellido",
    firstName: "Nombre",
    profile: "Perfil",
    embody: "Representar a",
    visible: "Visible",
    popup: "Ventana emergente",
    visibleHomeLea: "Visible",
    endDate: "Fecha de finalización",
    startDate: "Fecha de inicio",
    contractTypeColor: "Color del contrato",
    none_duplicated_user: "Ningún usuario para combinar",
    skill: {
      title: "Competencia",
    },
    skillCategory: {
      title: "Categoría",
    },
    skill_session: {
      generate: "Generar períodos",
      empty:
        "Debe introducir el número de períodos que quiere crear en la configuración del módulo para poder configurarlos",
      generation_success: "Períodos generados correctamente",
      existing_session: "Está a punto de eliminar periodos existentes. ¿Seguro que quiere continuar?",
    },
    skillReferential: {
      title: "Referencia de competencias",
      edit: "Modificar la referencia",
    },
    skill_import_france_competence: {
      title: "Importer tous les référentiels France Compétences",
      confirm: "Êtes-vous sûr de vouloir charger tous les référentiels France Compétences ?",
      success: "Référentiels importés avec succès !",
    },
    navigation: {
      users: "Usuarios",
      trainings: "Formaciones",
      modules: "Módulos",
      settings: "Configuración",
      general: "General",
      steering: "Dirección",
    },
    home: {
      title: "Configuración general",
      title2: "Vista de conjunto",
      title3: "Sincronización automática",
      title4: "Estadísticas generales",
      active: "Activado",
      unique_connection: "conexión única",
      apprentices_mentor: "Alumnos y mentores",
    },
    log: {
      title: ({ plural }) => plural(["Registro", "Registros"]),
      view: "Ver los datos modificados",
      modify_field: "Campo modificado",
      old_data: "Dato antiguo",
      data: "Nuevo dato",
      impersonation_chain: "Cadena de suplantación",
      impersonator_type: {
        zama: "Administrador Zama",
        studea: "Administrador Studea",
        studea_admin: "Administrador Studea",
        studea_manager: "Responsable Studea",
      },
    },
    ypareoReporting: {
      title: ({ plural }) => plural(["Informe Ypareo", "Informes Ypareo"]),
      view: "Ver el informe",
    },
    edusignReporting: {
      title: ({ plural }) => plural(["Informe Edusign", "Informes Edusign"]),
      view: "Ver el informe",
    },
    registrationAlert: {
      title: ({ plural }) => plural(["Alerta", "Alertas"]),
    },
    ammonReporting: {
      title: ({ plural }) => plural(["Informe Ammon", "Informes Ammon"]),
      view: "Ver el informe",
    },
    ggeReporting: {
      title: ({ plural }) => plural(["Informe GGE", "Informes GGE"]),
      view: "Ver el informe",
    },
    ssoReporting: {
      title: ({ plural }) => plural(["Informe SSO", "Informes SSO"]),
      view: "Ver el informe",
    },
    ofalinkReporting: {
      name: "Ofa Link",
      title: ({ plural }) => plural(["Informe Ofa Link", "Informes Ofa Link"]),
      view: "Ver el informe",
    },
    report: {
      title: ({ plural }) => plural(["Informe", "Informes"]),
      view: "Ver el informe",
    },
    mail: {
      title: ({ plural }) => plural(["Correo", "Correos"]),
      view: "Ver el contenido del correo",
      recipient: "Destinatario:",
      status: "Estado de envío:",
      sent_on: "Enviado el:",
      open_on: "Abierto el:",
      error_message: "Mensaje de error",
      no_error_message: "El servidor no ha devuelto ningún mensaje.",
    },
    registrationField: {
      title: ({ plural }) => plural(["Campo", "Campos"]),
    },
    registrationBlock: {
      title: ({ plural }) => plural(["Bloque", "Bloquea"]),
    },
    registrationTab: {
      title: ({ plural }) => plural(["Ficha", "Fichas"]),
    },
    registrationStep: {
      title: ({ plural }) => plural(["Paso", "Pasos"]),
    },
    registrationDataVersion: {
      title: ({ plural }) => plural(["Versión", "Versiones"]),
      notEmpty: "Ya hay fichas asociadas a esta versión.",
    },
    registrationDevice: {
      title: ({ plural }) => plural(["Dispositivo", "Dispositivos"]),
    },
    registrationDataConfiguration: "Modificar la configuración de la versión",
    cerfaParam: {
      title: ({ plural }) => plural(["Ajustes Cerfa", "Ajustes Cerfa"]),
    },
    role: {
      title: ({ plural }) => plural(["Función", "Funciones"]),
    },
    triad: {
      title: ({ plural }) => plural(["Trinomio", "Trinomios"]),
      delete_all_triad: {
        title: "Borrar todos los trinomios",
        confirmation: "Está seguro de querer eliminar todos los tríos de esta promoción ?",
        success: "Trinomios eliminados con éxito !",
      },
    },
    studeaUser: {
      title: ({ plural }) => plural(["Usuario", "Usuarios"]),
    },
    user: {
      title: ({ plural }) => plural(["Usuario", "Usuarios"]),
      actions: {
        keep_user: "Guardar",
        delete_user: "Eliminar",
        unselect_user: "Deseleccionar este usuario",
        reset_password: {
          success: "El enlace de restablecimiento de la contraseña se ha enviado al usuario",
        },
      },
      add_profile: "Añadir un perfil",
      warning_profile: "Eliminación de un perfil",
      warning_profile_text: "¿Está seguro de que desea eliminar este perfil?",
      last_connection: "Dernière connexion le : \n",
      search_user_by_name_or_mail: "Buscar un usuario por nombre o e-mail",
      import_users: "Importar usuarios",
      profile_config: "Configuración de perfiles",
      merge: "Fusión de usuarios",
      duplicated_user_count: "usuarios duplicados a combinar",
      merge_duplicated_user_confirmation: "¿Seguro que quiere combinar estos usuarios?",
      merge_success: "Combinación llevada a cabo correctamente",
      no_double_user: "Ningún duplicado encontrado",
      mail_address: "Dirección de correo electrónico",
      already_connected: "Ya se ha conectado al libro",
      yes: "Sí",
      no: "No",
      row: "Línea",
      reference_user: "Usuario de referencia",
      duplicated_user: "Duplicados",
      reset_choices: "Restablecer selecciones",
      options: "Opciones",
      account_creation: "Creación de la cuenta",
      username: "Nombre de usuario",
      external_id: "ID externo",
      birth_date: "Fecha de nacimiento",
      send_credential_back_to_user: "Volver a enviar las credenciales al usuario afectado",
      reference_user_is_not_duplicate: "El usuario de referencia no es un duplicado.",
      keep: "Guardar",
      delete: "Eliminar",
      export: "Exportar",
      send: "Registrar",
      profile_title: "Nombres de perfiles de usuario",
      users_profile_title_list: "Lista de nombres de perfiles de usuario",
      modify_profile: "Modificación del nombre",
      modification_succes: "Perfil modificado correctamente",
      no_mail_title: "Ningún enlace",
      no_mail: "Este usuario todavía no ha recibido ningún enlace de restablecimiento de la contraseña.",
      profile_user_info:
        "Crear los diferentes perfiles de responsable de libro con derechos específicos, que podrán asociarse después a los usuarios. Ejemplo: Gestor de asistencia, responsable pedagógico...",
      role: {
        NONE: "No",
        ALL: "Sí",
        VIEW: "Ver",
        EDIT: "Modificar",
        DELETE: "Eliminar",
      },
      erase_studeaManager_profile:
        "Tenga en cuenta que está a punto de eliminar los perfiles de folleto adjuntos a su cuenta",
    },
    profile_label: {
      titleAbbreviation: "Abreviatura",
      titlePlural: "Título en plural",
      titleWithArticle: "Título con artículo",
    },
    training: {
      title: ({ plural }) => plural(["Formación", "Formaciones"]),
      ufa_add_test: "Crear una formación de prueba",
      genere_triad_test: "Generar trinomios de prueba",
      generate_triad_test_confirmation: "¿Seguro que quiere crear trinomios de prueba en todas las formaciones? ",
      genere_triad_test_success: "Trinomios de prueba creados correctamente",
      genere_training_test_success: "Formación de prueba creada correctamente",
      import_triad: "Importar trinomios",
      confirmation_subtitle:
        "Esta supresión conllevará también la supresión de las promociones vinculadas a este curso.",
    },
    registration: {
      title: ({ plural }) => plural(["Inscripción", "Inscripciones"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Promoción", "Promociones"]),
      duplicate_on_next_year: "Duplicar la promoción en el año siguiente",
      duplicate: "Duplicar la promoción",
      delete: "Eliminar la promoción",
    },
    studeaManager: {
      title: ({ plural }) => plural(["Responsable del cuaderno", "Responsables de cuaderno"]),
    },
    variable: {
      title: ({ plural }) => plural(["Variable", "Variables"]),
    },
    modele: {
      title: ({ plural }) => plural(["Plantilla", "Plantillas"]),
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} copiado con éxito!`, `${named("name")} copiada con éxito!`]),
      title: ({ plural, named }) => plural([`Copiar este ${named("name")}`, `Copiar esta ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `¿Está seguro de querer copiar este ${named("name")}?`,
          `¿Está seguro de querer copiar esta ${named("name")}?`,
        ]),
      error: ({ plural, named }) =>
        plural([
          `Se ha producido un error al copiar este ${named("name")}. Por favor, inténtelo de nuevo más tarde.`,
          `Se ha producido un error al copiar esta ${named("name")}. Por favor, inténtelo de nuevo más tarde.`,
        ]),
    },
    design: {
      title: "Diseño",
    },
    dataAgreement: {
      title: ({ plural }) => plural(["Política de datos", "Políticas de datos"]),
    },
    institution: {
      title: ({ plural }) => plural(["Centro", "Centros"]),
      list: {
        title: "Centros activos",
      },
      export: {
        booklets: "Exportación de los cuadernos del centro",
        answers: "respuestas a los cuestionarios del año anterior",
      },
    },
    document: {
      title: ({ plural }) => plural(["Documento público", "Documentos públicos"]),
    },
    documentCategory: {
      title: ({ plural }) => plural(["Categoría de documento", "Categorías de documento"]),
    },
    helpDocument: {
      title: ({ plural }) => plural(["Ayuda online", "Ayudas online"]),
    },
    component: {
      title: ({ plural }) => plural(["Componente", "Componentes"]),
      export: {
        title: "respuestas a los cuestionarios del año anterior",
      },
    },
    degree: {
      title: ({ plural }) => plural(["Tipo de título", "Tipos de título"]),
    },
    contractType: {
      title: ({ plural }) => plural(["Tipo de contrato", "Tipos de contrato"]),
    },
    planContract: {
      title: ({ plural }) => plural(["Año de formación", "Años de formación"]),
      actions: {
        activate: {
          title: "Activar",
          success: "Año de formación activado correctamente",
        },
        activate_recruitment: {
          title: "Activar para contratación",
          success: "Activado para contratación correctamente",
        },
      },
    },
    titleRncp: {
      title: ({ plural }) => plural(["Título RNCP", "Títulos RNCP"]),
    },
    modulet: {
      title: ({ plural }) => plural(["Módulo", "Módulos"]),
      list: {
        title: "Gestión de módulos",
      },
      trainingCourse: {
        edit: {
          title: "Modificar las formaciones asociadas al módulo",
          success: "Formaciones asociadas al módulo modificadas correctamente",
        },
        displayActive: "Mostrar solo las formaciones asociadas al módulo",
      },
      config: {
        title: "Configuración del módulo",
      },
      skill_session: {
        title: "Generar períodos",
      },
      registration: {
        title: "Panel de registro",
      },
      skill_referential: {
        title: "Referencia de competencias",
        list: "Referencias",
        edit: "Modificación de la referencia",
        config: "Configuración del modulo",
      },
    },
    template: {
      title: ({ plural }) => plural(["Plantilla", "Plantillas"]),
      success: "Plantilla modificada correctamente !",
      duplicate: "Duplicar esta plantilla",
      default_template: "Plantilla por defecto",
    },
    absenceReason: {
      title: ({ plural }) => plural(["Motivo de ausencia", "Motivos de ausencia"]),
    },
    questionnaireConfig: {
      title: "Configuración del módulo de cuestionario",
      multiple_actions: "Modificación de cuestionarios",
      action_to_do: "Acciones a realizar",
      warning:
        "Esta acción modificará todos los cuestionarios del año seleccionado que tengan el título seleccionado. Los campos vacíos permanecerán sin cambios",
      confirmation: "¿Confirmar modificación de datos?",
      success: "¡Cuestionarios modificados con éxito!",
    },
    ypareoConfig: {
      title: "Configuración del módulo Ypareo",
      get_directories: "Recuperar los directorios ypareo",
      reference_tables: {
        tab_title: "Tablas de referencia",
        intro:
          "Estas tablas se obtienen una vez desde Ypareo y se almacenan en Studea, para que sincronizar un expediente ya no necesite consultar Ypareo en cada envío.",
        refresh_button: "Actualizar desde Ypareo",
        refresh_success: "Tabla actualizada correctamente",
        mapping_saved: "Correspondencia guardada",
        last_refreshed_at: "Última actualización: {date}",
        never_refreshed: "Nunca actualizada",
        active_count: ({ plural, named }) =>
          plural([`${named("count")} fila activa`, `${named("count")} filas activas`]),
        show_inactive: "Mostrar las filas inactivas",
        code_column: "Código Ypareo (solo lectura)",
        label_column: "Etiqueta Ypareo (solo lectura)",
        mapping_column: "Correspondencia Studea",
        active_column: "Estado",
        active_value: "Activa",
        inactive_value: "Inactiva",
        no_studea_values:
          "Actualmente no hay ningún valor Studea disponible para este referencial: la correspondencia aún no se puede introducir.",
        read_only_notice:
          "Este referencial se puede consultar y actualizar, pero su correspondencia Studea no se introduce fila a fila: se realiza por combinación (situación, título, año, repetidor) en una pantalla dedicada.",
        no_rows: "Sin filas para este referencial. Lance una actualización para completarlo desde Ypareo.",
        mapping_aria_label: "Correspondencia Studea para {label}",
        table_caption: "Tabla de referencia {label}",
        types: {
          civility: "Tratamiento",
          nationality: "Nacionalidad",
          birth_country: "País de nacimiento",
          school_origin: "Origen escolar",
          obtained_degree: "Título obtenido",
          employer_type: "Tipo de empleador",
          situation: "Situación",
        },
      },
      exclusion_refresh: {
        intro:
          "Estas listas se obtienen una vez desde Ypareo y se almacenan en Studea, para alimentar los filtros de exclusión de la pestaña siguiente.",
        refresh_button: "Actualizar desde Ypareo",
        refresh_success: "Lista actualizada correctamente",
        last_refreshed_at: "Última actualización: {date}",
        never_refreshed: "Nunca actualizada",
        active_count: ({ plural, named }) =>
          plural([`${named("count")} fila activa`, `${named("count")} filas activas`]),
        types: {
          status: "Estatus",
          group: "Grupos",
        },
      },
      exclusion_list: {
        add_button: "Añadir una exclusión",
        empty: "No hay ninguna exclusión registrada",
        code_column: "Código",
        label_column: "Etiqueta",
        delete_button: "Eliminar {code}",
        delete_confirm_title: "¿Quitar esta exclusión?",
        delete_confirm_subtitle: "El código {code} se quitará de la lista.",
        delete_success: "Exclusión eliminada correctamente",
        modal_title: "Añadir una exclusión — {label}",
        add_button_inclusion: "Añadir una inclusión",
        modal_title_inclusion: "Añadir una inclusión — {label}",
        empty_inclusion: "No hay ninguna inclusión registrada",
        delete_confirm_title_inclusion: "¿Quitar esta inclusión?",
        delete_confirm_subtitle_inclusion: "El código {code} se quitará de la lista.",
        delete_success_inclusion: "Inclusión eliminada correctamente",
        search_label: "Buscar en {label}",
        search_placeholder: "Introduzca al menos 3 caracteres",
        searching: "Buscando...",
        no_result: "Sin resultados",
        results_found: ({ plural, named }) =>
          plural([`${named("count")} resultado encontrado`, `${named("count")} resultados encontrados`]),
        add_result: "Añadir {label}",
        add_success: "{label} añadido correctamente",
        included_group_title: "Códigos de grupo incluidos",
        previous_group_title: "Códigos de grupo que se importarán a pesar de pertenecer al período anterior",
        excluded_group_title: "Códigos de grupo excluidos",
        excluded_apprentice_title: "Aprendices excluidos",
        mode_help: "El cambio de modo solo se aplicará al guardar la próxima vez.",
      },
    },
    driverLicenceConfig: {
      title: "Configuración del módulo carnet de conducir",
    },
    studeaManagerProfile: {
      title: ({ plural }) => plural(["Perfil de responsable del cuaderno", "Perfiles de responsable del cuaderno"]),
      all_access: "Activar todos los permisos",
    },
    historic: {
      title: "Historial",
    },
    statistic: {
      title: "Estadísticas",
      general: "General",
      questionnaires: "Cuestionarios",
      absence: "Ausencias",
      course: "Seguimiento del curso",
      global_export: "Exportar las estadisticas",
      updated_on: "actualizado el",
      indicators_generated: "Indicadores adicionales que se están generando actualmente",
    },
    export: {
      title: "Exportaciones",
      year: "Promociones",
      available_exports: "Exportaciones disponibles",
      signature_questionnaire_all: "Exportar las firmas de los cuestionarios de todos los diplomas",
      absence_cumulate_by_diploma: "Exportar las ausencias por diploma  ",
      absence_by_apprentice: "Exportar las ausencias por aprendiz",
      company_visits: "Exportar las visitas en empresa",
      contract: "Exportar los contratos",
      dashboard: "Exportar el tablero de control",
      summary_table: "Exportar la tabla recapitulativa",
      questionnaire: "Exportar un cuestionario",
      questionnaire_code_count: "Exportar el número de cuestionarios por código",
      category_questionnaires: "Cuestionarios",
      category_absences: "Ausencias",
      category_contracts: "Contratos",
      category_general: "General",
      category_reversibility: "Reversibilidad",
      year_filter_hint: "Este filtro solo se aplica a las exportaciones marcadas con el icono de calendario",
      year_filter_badge_tooltip: "Esta exportación tiene en cuenta el año seleccionado arriba",
      reversibility: "Exportar libretas, competencias y ausencias",
      reversibility_hint:
        "Archivo único organizado por institución y luego por promoción: libretas de aprendizaje en PDF con sus documentos adjuntos, evaluaciones de competencias en PDF, ausencias en formato Excel. Un manifiesto detalla el contenido realmente producido. Proceso largo.",
      reversibility_confirm_title: "¿Lanzar la exportación de reversibilidad?",
      reversibility_confirm_text:
        "Esta acción genera un archivo de varios gigabytes y puede tardar varias horas. Lánzala solo en la salida definitiva del cliente.",
      reversibility_error: "No se pudo generar la exportación de reversibilidad. Inténtelo de nuevo más tarde.",
    },
    duplicate: {
      title: "Duplicados",
    },
    archive: {
      title: "Archivado",
    },
    news: {
      title: ({ plural }) => plural(["Noticia", "Noticias"]),
      news_list: "Lista de noticias",
      list: {
        title: "Noticias",
        uploaded_date: "Publicado el",
        see_more: "Ver más",
        see_all_news: "Recuperar todas las noticias",
        go_back_newslist: "Volver a la lista de noticias",
      },
    },
    import: {
      modele: "Modelo de archivo para descargar",
      triad_new_file:
        "Atención: hay disponible un nuevo modelo desde 18/09/2023.\n" +
        "          Descárguelo y úselo para cargar sus trinomios.",
      triad_update:
        "Solo se actualizarán los miembros que no tengan trinomio. No se actualizará ningún dato (apellido, nombre o e-mail) de un usuario existente.",
      thanks: "No modifique ni elimine las columnas del modelo",
      contract_type_id: "ID tipos de contrato (columna AM)",
    },
    text: "Texto",
    dateToDisplay: "Fecha en que debe publicarse",
    emailContent: "Contenido e-mail",
    picture: "Imagen",
    subTitle: "Subtítulo",
    tag: "Etiqueta",
    video: "Vídeo",
    activate_notification: "Activar notificaciones",
    activate_notification_success: "Actualizar la preferencia de notificación",
    tutorial: {
      title: ({ plural }) => plural(["Tutorial", "Tutorials"]),
      admin: "Administrador",
      studea_manager: "Gestor de folletos",
      user: "Usuario",
    },
    ammonConfig: {
      title: "Configuración del módulo Ammon",
      synchronisation: "Sincronización",
      confirmation: "¿Está seguro de que desea iniciar la sincronización con Ammon?",
    },
    contractRuptureConfig: {
      title: "Declaración de rescisión del contrato por parte del aprendiz o de la empresa",
    },
    reporting: {
      list: ({ named }) => `Les des rapports ${named("name")}`,
    },
    cfa_config: {
      success: "Configuración del CFA modificada correctamente !",
    },
    last_report: "Último informe",
    opco: {
      success_update: "¡OPCO modificado con éxito!",
      synchronisation_confirmation: "¿Está seguro de que desea sincronizar este OPCO?",
      synchronisation_confirmation_subtitle:
        "Está a punto de iniciar manualmente la sincronización del OPCO {opco}.<br /><br />Una sincronización automática ya se ejecuta cada noche entre las 00:00 y las 03:00.<br /><br />️ En caso de llamadas repetidas fuera de este intervalo horario, el OPCO puede suspender el acceso a su API.<br /><br />¿Confirma que desea iniciar la sincronización?",
      success_synchronisation: "¡Sincronización iniciada!",
      api_key: {
        valid: "Clave API CFaDock válida",
        invalid: "Clave API CFaDock no válida",
      },
      error_synchronisation: "Clave API CFaDock inválida",
      invoice: {
        details: "Ver los detalles de facturación",
        modal: {
          title: "Detalles de facturación de {opco}",
        },
        success_update: "¡Dirección de facturación actualizada con éxito!",
      },
      files: {
        title: "Expedientes OPCO (3 años)",
        subtitle: "Todos los OPCO combinados",
      },
      sync_files: {
        title: "Expedientes sincronizados",
        subtitle: "de tasa de correspondencia",
      },
      guide: {
        title: "Guía de lectura",
        baseline: "Comprender los indicadores de sincronización",
        sync_file: {
          title: "Expediente sincronizado",
          description:
            "Studea ha vinculado este expediente con su equivalente OPCO. Los datos (estado, DECA, financiación) están actualizados.",
        },
        corresponding: {
          title: "Correspondencia probable",
          description:
            "Puntuación 4/5: un criterio no coincide. El expediente no se vincula automáticamente; se requiere una confirmación manual.",
        },
        progression: {
          title: "Barra de progreso",
          description:
            "Expedientes sincronizados / total de expedientes OPCO. En naranja si uno o varios expedientes están pendientes de confirmación.",
        },
        sync_report: {
          title: "Informe de sincronización",
          description:
            "Exportación XLSX: detalle de los criterios de correspondencia (SIRET, RNCP, fechas, nombres) para cada expediente.",
        },
        manual_sync: {
          title: "Sincronización manual",
          description:
            "Reservada para pruebas y casos excepcionales. La sincronización automática se ejecuta cada noche entre las 00:00 y las 03:00.",
        },
        inactive: {
          title: "OPCO inactivo",
          description: "Conexión no configurada. Póngase en contacto con su referente Studea para activarla.",
        },
        matching_criteria: {
          title: "Criterios de correspondencia (puntuación /5)",
          description:
            "Fecha de nacimiento del alumno · Nombre del alumno · SIRET de la empresa · Fecha de inicio del contrato · Código RNCP.<br><strong>5/5</strong> → sincronización automática  {'|'}  <strong>4/5</strong> → correspondencia probable (confirmación manual)  {'|'}  <strong>< 4/5</strong> → sin correspondencia.",
        },
      },
    },
    activateOption: "Activar/Desactivar",
    ia_competences: {
      config_confirmation:
        "¿Está seguro de que desea aplicar esta configuración IA-Competencias a las promociones seleccionadas?",
      config_success: "¡Configuración IA-Competencias aplicada con éxito!",
      reload_error: "Se produjo un error al recargar los datos.",
      tab_formations: "Formaciones",
      tab_promotions: "Promociones",
      help_text:
        "Seleccione las formaciones o promociones a la izquierda, elija los ajustes IA que desea aplicar y haga clic en Aplicar.",
      apply: "Aplicar",
      apply_sticky_aria: "Aplicar los ajustes de IA a la selección",
      apply_footer_aria: "Aplicar los ajustes de IA a la selección",
      features_title: "Funcionalidades IA",
      module1_title: "Referencial RNCP",
      module1_label: "Módulo 1",
      module2_title: "Misiones y actividades",
      module2_label: "Módulo 2",
      features_upcoming_title: "Funcionalidades próximas",
      feature_enrichment: "Enriquecimiento",
      feature_enrichment_desc: "Sugiere competencias complementarias a partir del título RNCP importado.",
      feature_program_breakdown: "Desglose de programas",
      feature_program_breakdown_desc: "Descompone un programa en semestres, unidades y módulos.",
      feature_matrix: "Matriz UE/Competencias",
      feature_matrix_desc: "Genera la matriz de correspondencia UE/competencias del referencial.",
      feature_mission_breakdown: "Desglose de misiones",
      feature_mission_breakdown_desc:
        "Transforma una misión en actividades estructuradas alineadas con el referencial.",
      feature_writing: "Asistente de redacción",
      feature_writing_desc: "Sugerencias contextuales para guiar al aprendiz en sus actividades.",
      feature_activity_skills: "Actividad/Competencias",
      feature_activity_skills_desc: "Identifica las competencias RNCP movilizadas y evalúa el nivel alcanzado.",
      profile_rp: "RP",
      profile_admin: "Admin",
      profile_apprentice: "Alternante",
      profile_tutor: "Tutor",
    },
  },
};
